import type { Theme } from "@mui/material";
import type { CSSProperties } from "react";
import { makeStyles } from "@/ui/kit/styles/makeStyles";

export default makeStyles()((theme: Theme) => ({
  simpleLabel: {
    position: "relative !important" as CSSProperties["position"],
    transform: "none !important",
    marginBottom: theme.spacing(1),
    pointerEvents: "initial",
  },
  readOnly: {
    "&, &:hover, &.Mui-focused": {
      ".MuiOutlinedInput-notchedOutline": {
        color: theme.palette.text.primary,
        boxShadow: "none",
        border: `1px dashed ${theme.palette.line.primary}`,
      },
    },
  },
  labelContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  fill: {
    backgroundColor: theme.palette.line.primary,
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover": {
      backgroundColor: theme.palette.background.default,
      ".MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    },
    "&.Mui-focused": {
      backgroundColor: theme.palette.background.default,
      ".MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.primary.light}`,
      },
    },
    "&.Mui-focused.Mui-error": {
      ".MuiOutlinedInput-notchedOutline": {
        boxShadow: `0px 0px 0px 2px ${theme.palette.error.lighter}`,
      },
    },
    "&.Mui-disabled": {
      ".MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    },
    readOnlyNotched: {
      border: "1px dashed red",
    },
  },
  fillReadOnly: {
    "&:hover": {
      backgroundColor: theme.palette.line.primary,
    },
  },
}));
